<template>
  <div
    class="icm_calculator icmcalc f-column mw-0"
    style="gap: 1rem"
  >
    <div>
      <div class="text-big weight_700">
        {{ $t('icm_calc.title') }}
      </div>
      <div class="text-semi-large clr-grey">
        {{ $t('icm_calc.subtitle') }}
      </div>
    </div>
    <div
      v-if="!resultData"
      class="f-column mw-0"
      style="gap: 1rem"
    >
      <div
        class="d-flex mt-4 f-wrap"
        style="gap: 1rem"
      >
        <div class="gw_box f-column flex-1">
          <div>
            <div class="text-semi-large weight_500">{{ $t('icm_calc.prizes') }}</div>
          </div>
          <SolfigrIcmTournamentStructure
            class="mt-4 flex-1"
            :namespace
            :icmTournament
            :maxPayouts="2048"
            :minPayouts="1"
            :hasType="false"
            @update:icmTournament="
              value =>
                handleIcmUpdate({
                  value,
                  key: `slfrm_icm_tournament`,
                })
            "
          />
        </div>

        <div class="gw_box f-column flex-1">
          <div>
            <div class="text-semi-large weight_500">{{ $t('icm_calc.stacks') }}</div>
          </div>

          <SolfigrIcmOtherStacks
            class="mt-4 flex-1"
            :namespace
            :maxPlayers="2048"
            :minPlayers="2"
            :icmPlayersAndStacks
            :hasBountyAvg="false"
            @update:icmPlayersAndStacks="
              value =>
                handleIcmUpdate({
                  value,
                  key: `slfrm_icm_playersAndStacks`,
                })
            "
          />
        </div>
      </div>

      <div
        v-if="errorMessage"
        class="clr-error no-shrink pt-1"
      >
        {{ errorMessage }}
      </div>

      <div
        v-if="!data_call.loading"
        class="gw_btn-v1 mb-4"
        :data-tst="`icm_calculate${canCalulate ? '' : '_disabled'}`"
        :class="`${canCalulate ? 'gw_btn_primary' : 'gw_btn_disabled no-events'}`"
        style="--clr-disabled: var(--clr-grey-2); --clr-back-disabled: var(--clr-black-2)"
        @click="calculate"
      >
        <div class="mdi mdi-calculator text-normal-large mr-1"></div>
        {{ $t('common.calculate') }}
      </div>
      <div
        v-else
        class="gw_btn-v1 gw_btn_primary no-events mb-4"
      >
        <LoaderSpinner
          v-show="data_call.loading"
          style="--size: 1.5rem; position: absolute"
        />
      </div>
    </div>
    <div
      v-else
      class="f-column mw-0 mb-4"
      style="gap: 1rem"
    >
      <IcmCalculatorResultTable :items="resultData.calculations" />

      <div
        class="d-flex ml-auto"
        style="gap: 0.5rem"
      >
        <div
          class="gw_btn-v1"
          data-tst="icm_reset"
          @click="reset(false)"
        >
          <i class="mdi mdi-pencil text-semi-large mr-2"></i>
          {{ $t('btn.edit') }}
        </div>
        <!-- <div
          class="gw_btn-v1"
          @click="reset(true)"
        >
          <i class="mdi mdi-autorenew text-semi-large mr-2"></i>
          {{ $t('btn.new') }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import fetch_mix from '@/mixins/fetch_mix'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import IcmCalculatorResultTable from '@/components/DataTables/v2/tables/IcmCalculatorResultTable/IcmCalculatorResultTable'
import SolfigrIcmTournamentStructure from '@/components/ConfigureSolution/SolfigrIcmTournamentStructure'
import SolfigrIcmOtherStacks from '@/components/ConfigureSolution/SolfigrIcmOtherStacks'

export default {
  name: 'IcmCalculatorView',
  components: {
    LoaderSpinner,
    IcmCalculatorResultTable,
    SolfigrIcmTournamentStructure,
    SolfigrIcmOtherStacks,
  },
  mixins: [fetch_mix, format_mix],
  data() {
    this.namespace = 'tmp/primary'
    return {
      data_call: {
        conf: {
          method: 'post',
          endpoint: 'custom-solutions/icm/calculator/',
          apiVersion: 'v4',
          data: null,
        },
        loading: false,
        loaded: false,
        status: 0,
        error: null,
      },
      resultData: null,
      errorMessage: '',
    }
  },
  methods: {
    handleIcmUpdate({ key, value }) {
      this.$store.dispatch(`${this.namespace}/slrfm_updateIcmInheritedValues`, {
        icmTournament: key === 'slfrm_icm_tournament' ? value : this.icmTournament,
        icmPlayersAndStacks:
          key === 'slfrm_icm_playersAndStacks' ? value : this.icmPlayersAndStacks,
        getTreePreview: false,
      })
    },

    reset(bool) {
      this.resultData = null
      if (bool) {
        this.$store.commit(`${this.namespace}/slfrm_reset`)
      }
    },
    async calculate() {
      if (this.data_call.loading) return
      this.data_call.error = null
      this.resultData = null
      this.errorMessage = ''

      this.data_call.conf.data = {
        prizes: this.icmTournament.payout_levels.map(item => item.prize),
        stacks: this.stacks,
      }
      const { data, error } = await this.fch_getData(this.data_call)
      if (this.data_call.canceled) {
        this.data_call.loading = true
        this.data_call.error = null
        return
      }
      if (error) {
        this.errorMessage = this.data_call.error?.response?.data?.data?.detail || ''
        if (this.errorMessage) return

        this.$store.dispatch('messages', {
          type: 'error',
          text: `${this.$t('messages.oops_error')} - Status ${this.data_call.status}`,
        })
        return
      }

      this.resultData = data
    },
  },
  computed: {
    icmTournament() {
      return this.$store.getters[`${this.namespace}/slfrm_icm_tournament`]
    },
    icmPlayersAndStacks() {
      return this.$store.getters[`${this.namespace}/slfrm_icm_playersAndStacks`]
    },
    stacks() {
      return this.icmPlayersAndStacks[
        this.icmPlayersAndStacks.stacks_distribution_type === 'sdt_manual'
          ? 'stacks_manual'
          : 'stacks_defined'
      ]
    },
    canCalulate() {
      return !this.icmTournament.errors.total_errors
    },
  },
}
</script>
